
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { dialogStyles } from '../Styles/dialogStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Loader from 'react-loader-spinner'
@inject('documentStore')
@observer
class DeleteDialog extends React.Component {

    onClickOk = () => {
        this.props.delete();
        this.props.cancelDelete()
    }

    onClickCancel = () => {
        this.props.cancelDelete()
    }

    render() {
        const { updateProgress } = this.props.documentStore;
        const { classes, title, message } = this.props;
        return (
            <Dialog disableBackdropClick={false} disableEscapeKeyDown={true} classes={{ paper: classes.submitDialog }} open={this.props.open} aria-labelledby="form-dialog-title">
                <DialogTitle>
                    <Typography className={classes.dialogHeading}>{title}</Typography>
                    <Typography className={classes.dialogSubHeading}>{message}</Typography>
                </DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <Button style={{ backgroundColor: '#acb4c6' }} variant="contained" className={classes.button} type="submit" onClick={(e) => this.onClickCancel()}>
                            Cancel
                        </Button>
                        {updateProgress ?
                            <Button variant="contained" className={classes.button} type="submit">
                                <Loader height={30} width={30} color={this.props.theme.palette.white} />
                            </Button> :
                            <Button variant="contained" className={classes.button} type="submit" onClick={(e) => this.onClickOk()}>
                                Ok
                            </Button>
                        }
                    </div>
                </DialogContent>
            </Dialog>
        )
    }
}

DeleteDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    cancelDelete: PropTypes.func.isRequired,
    delete: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired
};
export default withStyles(dialogStyles, { withTheme: true })(withRouter(DeleteDialog));
